export const getUsersEndPoint = 'workspace-users/users';
export const getWorkspacesEndPoint = 'workspace-users/workspaces';
export const getRolesEndPoint = '/roles';
export const updateUserRolesEndPoint = '/workspace-users';
export const renameWorkspaceEndPoint = '/workspaces/basic';
export const removeUserFromWorkspacesEndPoint = 'workspace-users/batch';
export const postUserWorkspaceEndpoint = 'workspace-users/batch';
